import { c as _c } from "react-compiler-runtime";
import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { Fragment, memo } from 'react';

// @ts-expect-error - Remove once type definitions are available
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import { TYPICAL_RESPONSE_TIME } from '../../../typical-response-time/constants/messageTypes';
// @ts-expect-error - Remove once type definitions are available
import { areMessagesGrouped } from '../../../message-history/operators/areMessagesGrouped';
import { getAttachmentsForMessage } from '../../../message-history/operators/getAttachmentsForMessage';
// @ts-expect-error - Remove once type definitions are available
import { getMessageId } from '../../../message-history/operators/getMessageId';
// @ts-expect-error - Remove once type definitions are available
import { getPositionDescriptors } from '../../../message-history/operators/getPositionDescriptors';
import MessageHistoryItem from './MessageHistoryItem';
import { useMessageHistoryPerformanceMeasurement } from '../../../performance-metrics/hooks/useMessageHistoryPerformanceMeasurement';
import { getHiddenBy } from '../../../common-message-format/operators/commonMessageGetters';
import { LAST } from '../../../constants/messagePositionDescriptors';
import { jsx as _jsx } from "react/jsx-runtime";
function MessageHistoryCoreComponent(t0) {
  const $ = _c(8);
  const {
    allowContactPromotions,
    channelName,
    fileAttachments: t1,
    friendlyNames,
    getAdditionalPositionDescriptors: t2,
    historyConfig,
    indexedAsyncFileAttachments,
    lastMessageId,
    recipientsMap,
    messages,
    portalId,
    presentSenderLocators: t3,
    senders,
    slots,
    threadId,
    ungatedForNewForkedComponent,
    ungatedForOmnichannelCallSummaryAiSkill: t4,
    ungatedForUnifiedCallSummary: t5,
    vid,
    visitorLastReadTimestamp,
    visitorRecipients
  } = t0;
  const fileAttachments = t1 === undefined ? ImmutableMap() : t1;
  const getAdditionalPositionDescriptors = t2 === undefined ? _temp : t2;
  let t6;
  if ($[0] !== t3) {
    t6 = t3 === undefined ? ImmutableSet() : t3;
    $[0] = t3;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const presentSenderLocators = t6;
  const ungatedForOmnichannelCallSummaryAiSkill = t4 === undefined ? false : t4;
  const ungatedForUnifiedCallSummary = t5 === undefined ? false : t5;
  let t7;
  if ($[2] !== lastMessageId || $[3] !== messages || $[4] !== threadId) {
    t7 = {
      componentName: "MessageHistoryCore",
      propsToTrack: {
        threadId,
        messages,
        lastMessageId
      }
    };
    $[2] = lastMessageId;
    $[3] = messages;
    $[4] = threadId;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  useMessageHistoryPerformanceMeasurement(t7);
  let t8;
  if ($[6] !== messages) {
    t8 = (message, index) => {
      const nextNextMessage = messages === null || messages === void 0 ? void 0 : messages.get(index + 2);
      if (nextNextMessage && areMessagesGrouped(message, nextNextMessage)) {
        return true;
      }
      return false;
    };
    $[6] = messages;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const getDontIncludeLastInGroup = t8;
  const additionalPositionDescriptors = getAdditionalPositionDescriptors(messages || List()) || ImmutableMap();
  return messages === null || messages === void 0 ? void 0 : messages.map((message_0, index_0) => {
    const previousMessage = index_0 > 0 ? messages.get(index_0 - 1) : undefined;
    const nextMessage = messages.get(index_0 + 1);
    let dontIncludeLastInGroup;
    if (getType(nextMessage) === TYPICAL_RESPONSE_TIME) {
      dontIncludeLastInGroup = getDontIncludeLastInGroup(message_0, index_0);
    }
    const fileAttachmentsForMessage = getAttachmentsForMessage(message_0, fileAttachments);
    let positionDescriptors = getPositionDescriptors(message_0, previousMessage, nextMessage, dontIncludeLastInGroup);
    const messageId = getMessageId(message_0);
    const hiddenBy = getHiddenBy(message_0);
    positionDescriptors = positionDescriptors.merge(additionalPositionDescriptors.get(messageId, ImmutableSet()));
    const isLastMessage = lastMessageId === getMessageId(message_0) || positionDescriptors.includes(LAST);
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(MessageHistoryItem, {
        allowContactPromotions: allowContactPromotions,
        hiddenBy: hiddenBy,
        historyConfig: historyConfig,
        fileAttachments: fileAttachmentsForMessage,
        fileAttachmentsForThread: fileAttachments,
        friendlyNames: friendlyNames,
        indexedAsyncFileAttachments: indexedAsyncFileAttachments,
        portalId: portalId,
        positionDescriptors: positionDescriptors,
        message: message_0,
        senders: senders,
        presentSenderLocators: presentSenderLocators,
        visitorLastReadTimestamp: visitorLastReadTimestamp,
        vid: vid,
        visitorRecipients: visitorRecipients,
        ungatedForNewForkedComponent: ungatedForNewForkedComponent,
        ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
        ungatedForUnifiedCallSummary: ungatedForUnifiedCallSummary,
        threadId: threadId,
        recipientsMap: recipientsMap,
        channelName: channelName,
        slots: slots,
        isLastMessage: isLastMessage
      })
    }, messageId);
  });
}
function _temp() {
  return ImmutableMap();
}
MessageHistoryCoreComponent.displayName = 'MessageHistory';
const MessageHistoryCore = /*#__PURE__*/memo(MessageHistoryCoreComponent);
export default MessageHistoryCore;